import storage from 'local-storage';
import { useCallback, useEffect, useState } from 'react';
import urlparam from 'urlparam';
import { useIsBusy } from '../../../data/hooks/ui/useIsBusy';
import config from '../../../configs/config';
import {
    useHasAPIConnection,
    usePrefillData,
} from '../../../data/hooks/sessionHooks';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import appPath from '../../../misc/appPath';

const CODE = urlparam('code');

const LoginViaLinkedin = (props) => {
    const prefill = usePrefillData(),
        isBusy = useIsBusy(),
        hasAPIConnection = useHasAPIConnection(),
        [isCheckingSession, setIsCheckingSession] = useState(false);

    const checkLogin = useCallback(() => {
        if (CODE && storage.get('llst')) {
            app.store.dispatch(app.actions.ui.busy());
            setIsCheckingSession(true);
            console.log('Performing linkedin login');
            app.api.session
                .linkedinLogin(
                    CODE,
                    storage.get('llst'),
                    config.linkedinCallback + '?webapp=' + location.origin + appPath('login/linkedin')
                )
                .then(function (response) {
                    if (response.is_new) {
                        app.history.replace('/login/linkedin/account');
                    } else if (prefill && prefill.code) {
                        app.history.push('/add/' + prefill.code);
                    }
                })
                .catch(async function (e) {
                    await dialogAlert('Something went wrong');
                    console.error('Failed to login via linkedin', e);
                    app.history.push('/');
                })
                .then(function (response) {
                    app.store.dispatch(app.actions.ui.free());
                });
        } else {
            app.history.push('/');
        }
    }, []);

    useEffect(() => {
        if (hasAPIConnection && !isBusy && !isCheckingSession) {
            let timeout = setTimeout(checkLogin, 250);
            return () => clearTimeout(timeout);
        }
    }, [hasAPIConnection, isBusy, isCheckingSession]);

    return null;
};

export default LoginViaLinkedin;
